import styled from '@emotion/styled';
import { HeaderProfile } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const HeaderWrapper = styled.div`
  position: relative;
  margin-bottom: 100px;

  ${mediaQuery('max')} {
    margin-bottom: 80px;
  }

  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

export const StyledHeaderProfile = styled(HeaderProfile)`
  box-shadow: none;
  padding: 25px 0 !important;
  text-align: center !important;
`;
